import { succeed, fail } from 'effect/Result';
export * from 'effect/Result';
export const unify = ((x) => x);
const _void = succeed(void 0);
const void_ = () => _void;
export { void_ as void };
export const tryPromise = async (options) => {
    try {
        return succeed(await options.try());
    }
    catch (error_) {
        return fail(options.catch(error_));
    }
};
//# sourceMappingURL=Result.js.map